module.exports = __webpack_public_path__ + "4341ea029a8db4864d50b3c643776292.png";